module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center admin"
  }, [_c('h1', {
    staticClass: "listTitle txtCenter"
  }, [_vm._v("ADMIN TOOLS")]), _vm._v(" "), _c('router-link', {
    staticClass: "routeAdmin center uppercase",
    attrs: {
      "to": "/brand-list",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("headerAdmin.brand")))]), _vm._v(" "), _c('router-link', {
    staticClass: "routeAdmin center",
    attrs: {
      "to": "/admin/zones",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("headerAdmin.zoneList")))]), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin center",
    attrs: {
      "to": "/admin/versionings",
      "exact": ""
    }
  }, [_vm._v("VERSIONINGS")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin-tools/categories",
      "exact": ""
    }
  }, [_vm._v("CATEGORIES")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin-tools/components",
      "exact": ""
    }
  }, [_vm._v("COMPONENTS")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin/countdowns-list",
      "exact": ""
    }
  }, [_vm._v("COUNTDOWN")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin/sso-system-list",
      "exact": ""
    }
  }, [_vm._v("SSO SYSTEM")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin/properties",
      "exact": ""
    }
  }, [_vm._v("PROPERTIES")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin/profiles",
      "exact": ""
    }
  }, [_vm._v("PROFILES")]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('router-link', {
    staticClass: "routeAdmin",
    attrs: {
      "to": "/admin/link-logs",
      "exact": ""
    }
  }, [_vm._v("LINK LOGS")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271ef4d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adminTools/Admin.vue
// module id = 3085
// module chunks = 0